export default "/_next/static/internship.svg";